// Chemins (URL) de l'application front — source unique pour les <Route>, <Link>, navigate()
// et les liens absolus partagés (catalogue, boutique publique, emails).
// Pour changer une URL, la modifier ici uniquement.

// ── Pages ────────────────────────────────────────────────────────────────────
export const ROUTES = {
  // Public
  accueil:          '/',
  vitrine:          '/vitrine',
  tarifs:           '/tarifs',
  confidentialite:  '/confidentialite',
  conditions:       '/conditions-utilisation',
  mentionsLegales:  '/mentions-legales',
  catalogue:        (slug) => `/catalogue/${slug}`,
  boutiquePublique: (slug) => `/${slug}`,

  // Authentification
  connexion:        '/login',
  inscription:      '/register',
  motDePasseOublie: '/forgot-password',

  // Application (connecté)
  dashboard:        '/dashboard',
  clients:          '/clients',
  dettes:           '/dettes',
  dettesClient:     (clientId) => `/clients/${clientId}/dettes`,
  factures:         '/factures',
  facture:          (id) => `/factures?id=${id}`,
  boutique:         '/produits',
  produitBoutique:  (id) => `/produits?produit=${id}`,
  magasin:          '/magasin',
  fournisseurs:     '/fournisseurs',
  fournisseur:      (id) => `/fournisseurs/${id}`,
  finances:         '/finances',
  mesFinances:      '/finances/mes-finances',
  monCompte:        '/finances/compte',
  parametres:       '/parametres',
  // Onglet précis des paramètres (ex. 'compte-profil', 'compte-securite')
  parametresOnglet: (onglet) => `/parametres?onglet=${onglet}`,
  statistiques:     '/statistiques',
  notifications:    '/notifications',
  messages:         '/messages',
  guide:            '/guide',
  // Ancienne page profil : redirige vers Paramètres › Mon compte › Profil
  profil:           '/profil',

  // Administration
  admin:             '/admin',
  adminUtilisateurs: '/admin/utilisateurs',
  adminModeration:   '/admin/moderation',
  adminVitrines:     '/admin/vitrines',
  adminJournal:      '/admin/journal',
};

// ── Motifs de routes (paramètres React Router) — utilisés seulement dans App.jsx ──
export const MOTIFS = {
  catalogue:        '/catalogue/:slug',
  boutiquePublique: '/:slug',
  dettesClient:     '/clients/:clientId/dettes',
  fournisseur:      '/fournisseurs/:fournisseurId',
  inconnue:         '*',
};

// ── Liens absolus (à partager hors de l'application) ─────────────────────────
export const urlAbsolue = (chemin = '/') => `${window.location.origin}${chemin}`;

// ── Contact ──────────────────────────────────────────────────────────────────
export const EMAIL_CONTACT = 'gestrack.gt@gmail.com';
// Compte administrateur (accès au panneau /admin) — même adresse que le contact
export const EMAIL_ADMIN = EMAIL_CONTACT;

// Lien WhatsApp : wa.me exige le numéro international, sans + ni espaces. Un numéro camerounais
// saisi sur 9 chiffres (6XX XXX XXX) reçoit l'indicatif 237 — sans lui, WhatsApp répond que le
// profil n'existe pas. Null si aucun numéro. message : texte prérempli (facultatif).
const INDICATIF_PAYS = '237';
const numeroInternational = (numero) => {
  const chiffres = String(numero || '').replace(/\D/g, '').replace(/^00/, '');
  return chiffres.length === 9 ? INDICATIF_PAYS + chiffres : chiffres;
};
export const lienWhatsApp = (numero, message) => {
  const chiffres = numeroInternational(numero);
  if (!chiffres) return null;
  return `https://wa.me/${chiffres}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};

// Lien d'appel téléphonique (ouvre le clavier du téléphone, numéro déjà composé)
export const lienAppel = (numero) => {
  const chiffres = numeroInternational(numero);
  return chiffres ? `tel:+${chiffres}` : null;
};

// Lien mailto avec sujet / corps optionnels
export const mailto = (email = EMAIL_CONTACT, { sujet, corps } = {}) => {
  const params = [];
  if (sujet) params.push(`subject=${encodeURIComponent(sujet)}`);
  if (corps) params.push(`body=${encodeURIComponent(corps)}`);
  return `mailto:${email}${params.length ? `?${params.join('&')}` : ''}`;
};
